import type { ModelCapabilitiesInfo } from '@localagent/sdk';
import { ModelCapabilityPills, ModelPricingCell } from '../providers/ModelCatalogCells';
import { LoadingState } from '@localagent/ui/components/shogun-spinner';

interface ModelCapabilitiesDisplayProps {
  capabilities: ModelCapabilitiesInfo | null;
  loading?: boolean;
}

function formatTokens(tokens: number): string {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(0)}M`;
  if (tokens >= 1000) return `${Math.round(tokens / 1000)}K`;
  return String(tokens);
}

export function ModelCapabilitiesDisplay({ capabilities, loading }: ModelCapabilitiesDisplayProps) {
  if (loading) {
    return (
      <LoadingState variant="inline" data-testid="model-capabilities-info" label="Loading model info..." />
    );
  }

  if (!capabilities) {
    return (
      <div data-testid="model-capabilities-info" className="text-xs text-muted-foreground">
        Unknown model capabilities
      </div>
    );
  }

  return (
    <div data-testid="model-capabilities-info" className="flex items-center gap-3 text-xs text-muted-foreground">
      <span data-testid="model-context-window">
        {formatTokens(capabilities.context_window)} context window
      </span>
      <span className="text-border">|</span>
      <span data-testid="model-max-output">
        {formatTokens(capabilities.max_output_tokens)} max output
      </span>
      {/*
        Same components the Providers models table uses: one source, no
        second derivation. Both render nothing when the provider was silent.
      */}
      <span className="text-border">|</span>
      <ModelCapabilityPills flags={capabilities} />
      <span className="text-border">|</span>
      <ModelPricingCell pricing={capabilities.pricing} />
    </div>
  );
}
